import { css } from '@emotion/react';
import { FieldobjectGrid } from './_mixin.mixin';

export default $ => css`
  .grid-row-min-content {
    grid-template-rows: min-content;
    grid-auto-rows: minmax(0, 1fr);
  }

  /* Each row sizes to its own content, never forcing empty space the way grid-row-min-content's
     minmax(0, 1fr) tracks always do. Rows that fit hand their unused share of the page to rows
     that overflow (see distributeRowHeights in Workpage.jsx).

     The actual height cap is applied in JS (see useShrinkToContentRowHeights in Workpage.jsx) as
     an explicit pixel height on each .workpage-widget. .worktray's own height: 100% (in
     _worktray.css.js) does resolve against that correctly — the reason it kept rendering at a
     fixed size regardless was a separate, unrelated .worktray min-height: 500px rule in
     _uwestyles.css.jsx, which unconditionally floors every worktray's height and silently
     defeated every shrink-to-content attempt (CSS or JS) until found via devtools. align-content:
     start stops grid's default stretch-to-fill from inflating rows before JS gets a chance to
     size them.
  */
  .workpage.grid-row-shrink-content {
    align-content: start;

    .worktray {
      min-height: 0;
    }
  }

  @media (min-width: 768px) {
    .smallTwoRows.default-all-row > * > * {
      grid-column-start: 1;
      grid-column-end: 4;
    }

    ${new FieldobjectGrid('smallOneRow', 1).include($)};
    ${new FieldobjectGrid('smallTwoRows', 2).include($)};
    ${new FieldobjectGrid('smallThreeRows', 3).include($)};
    ${new FieldobjectGrid('smallFourRows', 4).include($)};
    ${new FieldobjectGrid('smallFiveRows', 5).include($)};

    ${new FieldobjectGrid('grid-1-columns', 1).include($)};
    ${css([1, 2, 3, 4, 5].map(i => new FieldobjectGrid(`grid-${i}-columns`, i).include($)))};
  }
`;
